var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0156 3.02344H8.01562C7.48519 3.02344 6.97648 3.23415 6.60141 3.60922C6.22634 3.9843 6.01563 4.493 6.01562 5.02344V19.0234C6.01563 19.5539 6.22634 20.0626 6.60141 20.4377C6.97648 20.8127 7.48519 21.0234 8.01562 21.0234H16.0156C16.5461 21.0234 17.0548 20.8127 17.4298 20.4377C17.8049 20.0626 18.0156 19.5539 18.0156 19.0234V5.02344C18.0156 4.493 17.8049 3.9843 17.4298 3.60922C17.0548 3.23415 16.5461 3.02344 16.0156 3.02344H14.0156M10.0156 3.02344H14.0156M10.0156 3.02344V4.02344M14.0156 3.02344V4.02344M10.0156 4.02344C10.0156 4.28865 10.121 4.54301 10.3085 4.73054C10.4961 4.91808 10.7504 5.02344 11.0156 5.02344H13.0156C13.2808 5.02344 13.5352 4.91808 13.7227 4.73054C13.9103 4.54301 14.0156 4.28865 14.0156 4.02344M10.0156 4.02344H14.0156",
    stroke: "#8E96A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingPhone);
export default __webpack_public_path__ + "static/media/icon_setting_phone.b7ed1dd0d02ef818401c6c163d3251cb.svg";
export { ForwardRef as ReactComponent };